import React from 'react';

import { makeStyles, StylesProvider, ThemeProvider } from '@mui/styles';

import { createTheme, responsiveFontSizes } from '@mui/material/styles';
import BasicBucket from './components/templates/BasicBucket';
import CardList from './components/organisms/CardList';
import About from './components/organisms/About';
import Galery from './components/organisms/Galery';
import Contact from './components/organisms/Contact';

import serguei from './assets/serguei3.jpg';
import noumea from './assets/noumea.jpg';
import shannel from './assets/shannel.jpg';
import saskia from './assets/saskia4.jpg';
import sato from './assets/sato.jpg';
import romy from './assets/romy.jpg';
import themis from './assets/themis.jpeg';
import umeria from './assets/umeria.jpeg';

import './App.css';

const useStyles = makeStyles(() => ({
  title: {
    margin: '2em auto',
    fontFamily: 'Goldplay !important',

    fontSize: 30,
  },
  containerGray: {
    backgroundColor: '#f8f8f8',
    width: '80%',
    margin: '1em auto',
    padding: '1em',
  },
}));

const cats = [
  {
    title: 'Serguei',
    image: serguei,
    description: 'Né en 2021, beau mâle black smock doux et très calin !',
  },
  {
    title: 'Nouméa',
    image: noumea,
    description: 'Jolie femelle douce, calme et gentille de couleur neva',
  },
  {
    title: 'Saskia',
    image: saskia,
    description: 'Jeune et adorable femelle tortie, câline et joueuse',
  },
  {
    title: 'Shannel Queen',
    image: shannel,
    description: 'Née a la maison, bleu smoke blanc et blanc adorable et câline',
  },
  {
    title: 'Sato',
    image: sato,
    description: 'Surnommé petit caramel, il est très joueur et câlin',
  },
  {
    title: 'Romy',
    image: romy,
    description:
      'Magnifique femelle neva mascarade première arrivée qui a donnée son nom à la chatterie',
  },
  {
    title: 'Thémis',
    image: themis,
    description: "Elle est née a la maison ! Son surnom c'est Bouboule",
  },
  {
    title: "U'méria",
    image: umeria,
    description: 'Superbe rousse née à la maison et devenue résidente',
  },
];

let theme = createTheme();
theme = responsiveFontSizes(theme);

const App = () => {
  const classes = useStyles();
  return (
    <StylesProvider injectFirst>
      <ThemeProvider theme={theme}>
        <div>
          <BasicBucket>
            <div className={classes.containerGray}>
              <div>
                <p className={classes.title}>À propos 🗣</p>
                <About />
              </div>
            </div>
            <p className={classes.title}>Les résidents et résidentes du domaine 😻</p>
            <CardList array={cats} />

            <div className={classes.containerGray}>
              <p className={classes.title}>Gallerie 👀</p>
              <p>
                Voici quelques photographies des chats et chattes du Domaine. Ce sont des images de
                portées différentes et de maman différentes. Certains chatons sont encore disponible
                à l&apos;achat. Pour toutes demande de photos de portées en cours, n&apos;hésitez
                pas à me contacter ! :)
              </p>
              <Galery />
            </div>
            <div>
              <p className={classes.title}>Contactez-moi 👋</p>
              <Contact />
            </div>
          </BasicBucket>
        </div>
      </ThemeProvider>
    </StylesProvider>
  );
};

export default App;
